'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  name: 'htmlTag',
  lookup: function lookup(options) {
    var found = void 0;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};